exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@charset \"UTF-8\";\n/* CSS Document */\n/*メインコンテンツ系*/\n/*tooltip font*/\n/*ステータスカラー*/\n/* Sass Document */\n/* Filetype Web Font **********************************************************/\n.page-block {\n  padding-bottom: 68px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  background-color: #f0f0f0; }\n.scroll-y {\n  height: 100%;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box; }\n.layout-header {\n  background-color: white; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa8Billing/wa8006/wa8006.component.scss
// module id = ../../../../../src/app/pages/wa8Billing/wa8006/wa8006.component.scss
// module chunks = main